import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../../component/menu/Header";
import SideMenu from "../../../component/menu/SideMenu";
import { constants } from "../../../constant/constants";
import FormHeaderComponent from "../../../component/FormHeaderComponent";
import SupplierAddEditComponent from "../../../component/inventory/supplier/SupplierAddEditComponent";
import ApiService from "../../../utils/ApiService";
import useUserStore from "../../../stores/store";
import SupplierSkeleton from "../../../component/inventory/supplier/SupplierSkeleton";

export default function SupplierEdit() {
  const { user, showNotification } = useUserStore();
  const { supplierId } = useParams();
  const [supplierDetails, setSupplierDetails] = useState();
  const [loading, setLoading] = useState(true);

  async function getIngredientDetails(supplierId) {
    try {
      const res = await ApiService.INVENTORY_SUPPLIER_DETAIL_WITH_ID(supplierId, user.token.token);
      if (res.code !== 200) {
        showNotification(res.data.message);
        setLoading(false);
        return;
      }
      const { payload } = res;
      const { record } = payload;
      const { restaurantId, ...recordWithoutRetaurantId } = record;
      setSupplierDetails(recordWithoutRetaurantId);
      setLoading(false);
    } catch (err) {
      showNotification(err.response.data.message);
      setLoading(false);
      return;
    }
  }

  useEffect(() => {
    if (Boolean(supplierId)) {
      getIngredientDetails(supplierId);
    }
  }, [supplierId]);

  return (
    <div className="flex flex-col">
      {/* <CustomLoader /> */}
      <Header title={`McDonalds Food Chains`} menu={constants.MENU.INVENTORY} currentMenuKey={"T_7_S_7_L_3"} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.INVENTORY} />
        <div className="p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <FormHeaderComponent title={"Edit Supplier"} listRoute="/inventory/supplier" />
          </div>

          <div className="w-full flex justify-center">
            {loading && !Boolean(supplierDetails) ? (
              <SupplierSkeleton />
            ) : (
              <SupplierAddEditComponent data={supplierDetails} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
